<script lang="ts">
	//UI
	import { DefaultLoading, XIcon } from "@hitit/new_ui/src";
	import EditSave from "../Common/EditSave.svelte";
	import OrderItemList from "./OrderItemList.svelte";
	import AreYouSure from "@hitit/hub/src/v7/components/common/AreYouSure.svelte";

	//Image
	import card from "@hitit/hub/src/assets/Icons/order_detail_card.png";
	import cash from "@hitit/hub/src/assets/Icons/order_detail_cash.png";
	import unknown from "@hitit/hub/src/assets/Icons/order_detail_unknown.png";
	import copy from "@hitit/hub/src/assets/order/copy.png";
	import linkCopy from "@hitit/hub/src/assets/order/linkCopy.png";

	//Utils
	import type { CategoryMinData, OrderData, PaymentData } from "@hitit/api";
	import type { AxiosResponse } from "axios";
	import { formatNumber } from "@hitit/utils";
	import { t, store, api, notifications } from "@hitit/hub/src/stores";
	import { processingDate } from "@hitit/hub/src/v7/utils/Date";
	import ComponentLoading from "@hitit/hub/src/v7/components/common/ComponentLoading.svelte";
	import { popup } from "@hitit/hub/src/v7/store";
	import { createEventDispatcher } from "svelte";

	export let paymentResponse: PaymentResponse;
	export let storeId: string;
	export let orderId: string;
	export let orderDetailPath: string;
	export let selectOrderIndex: number;
	export let orderStatus: string | undefined = undefined;

	$:console.log('orderStatus',orderStatus)

	const dispatch = createEventDispatcher();

	type PaymentResponse = Promise<AxiosResponse<{ paymentDTOs: PaymentData[] }>>;

	let editmode = false;
	let loading = false;
	let storeItemMin: CategoryMinData[] = [];
	let orderCancelBtnStatus = false;
	let orderData: OrderData;

	async function editHandler() {
		if (!editmode) {
			editmode = true;
			return;
		}
		try {
			loading = true;
			alert("test");
		} catch (e) {
			console.log(e);
		} finally {
			loading = false;
			editmode = false;
		}
	}

	function clipboardCopy(text: string) {
		navigator.clipboard.writeText(text);
	}

	function getPaymentImage(paymentMethod: string) {
		if (paymentMethod === "INSTORE_CASH") {
			return cash;
		} else if (paymentMethod === "INSTORE_CAT") {
			return card;
		} else {
			return unknown;
		}
	}

	function computeRedeemdPoint(order: OrderData) {
		const redeemdValue = order.orderRewardDTO?.redeemed?.reward || 0;
		return Math.abs(redeemdValue);
	}

	function changeImage(orderPaymentMethod: string, orderStatus: string) {
		dispatch("CHANGE_IMAGE", {
			orderPaymentMethod,
			orderStatus,
			selectOrderIndex,
		});
	}

	async function orderCancelHandler() {
		const orderId = orderData.id!;
		const storeId = orderData.storeid!;
		const newOrderStatus = "CANCELLED";
		try {
			const {
				data: { orderDTO },
			} = await $api.postOrderStatus(storeId, orderId, newOrderStatus);
			changeImage(orderDTO.orderPaymentMethod!, orderDTO.orderStatus!);
			loadData($store?.id);
		} catch (e) {
			const error = e as Error;
			const errorMessage = `
				ERROR STATUS : ${error.message},<br>
				다시 한번 확인 바랍니다.
				`;
			notifications.append("ERROR", errorMessage, "", undefined, "ERROR");
			console.log(e);
		}
	}

	// 주문완료로 롤백 api 개발중
	async function orderRevertHandler() {
		const orderId = orderData.id!;
		const storeId = orderData.storeid!;
		const newOrderStatus = "CLOSED";
		try {
			const {
				data: { orderDTO },
			} = await $api.postOrderStatus(storeId, orderId, newOrderStatus);
		} catch (e) {
			const error = e as Error;
			const errorMessage = `
				ERROR STATUS : ${error.message},<br>
				다시 한번 확인 바랍니다.
				`;
			notifications.append("ERROR", errorMessage, "", undefined, "ERROR");
			console.log(e);
		}
	}

	function orderCancelBtn() {
		$popup = {
			component: AreYouSure,
			props: {
				textTranslation: `대표님의 걱정어린 재확인 &#58; </br> 해당 주문을 '정말로' 취소로 변경하시겠습니까?`,
				accept: () => {
					orderCancelHandler();
					orderStatus = undefined
					$popup = undefined;
				},
				cancel: () => ($popup = undefined),
				imageSrc: "/img/icons/bkWarning.png",
			},
		};
	}

	function orderRevertBtn() {
		$popup = {
			component: AreYouSure,
			props: {
				textTranslation: `대표님의 걱정어린 재확인 &#58; </br> 해당 주문을 '정말로' 완료로 되돌리시겠습니까?`,
				accept: () => {
					orderRevertHandler();
					$popup = undefined;
				},
				cancel: () => ($popup = undefined),
				imageSrc: "/img/icons/bkWarning.png",
			},
		};
	}

	// payment들이 모두 결제 취소인 상태면 orderStatus 변경
	function orderCancelBtnCheck() {
		paymentResponse.then((value) => {
			console.log('value.data.paymentDTOs',value.data.paymentDTOs)
			orderCancelBtnStatus = value.data.paymentDTOs.every(
				(v) => v.paymentStatus === "REFUNDED"
			);
		});
	}

	async function loadData(storeId: string = "") {
		const orderResponse = await $api.getOrder(storeId, orderId);
		orderData = orderResponse.data.orderDTO;
		const response = await $api.getStoreItemsMin(storeId);
		storeItemMin = response.data.categoryMinDTOs;
	}

	$: loadData(storeId);
	$: orderCancelBtnCheck();
</script>

<div class="item-list card" t-id="OrderTab">
	<!-- api 미구현으로 인해 수정버튼 비활성화 -->
	<!-- <EditSave actionHandler={editHandler} editmode={editmode} /> -->
	{#if loading}
		<ComponentLoading />
	{/if}
	<div class="header row">
		<div class="col product">{$t("hub.order.item")}</div>
		<div class="col price">{$t("hub.order.item_price")}</div>
		<div class="col count">{$t("hub.order.item_count")}</div>
		<div class="col total">{$t("hub.order.item_amount")}</div>
	</div>
	<div class="seperate-bar" />
	<div class="body">
		{#if orderData}
			<OrderItemList
				orderDTO={orderData}
				storeItemMin={storeItemMin}
				editmode={editmode}
			/>
		{:else}
			<div class="loading">
				<DefaultLoading />
			</div>
		{/if}
	</div>
</div>
<div class="payment-wrapper">
	{#if orderData}
		<div class="payment-card card">
			<div class="payment-info-wrapper">
				<span class="payment-title">{$t("hub.order.order_status")}</span>
				<div class="payment-widget">
					<div class="widget-box">
						<div class="widget">
							<div class="check-icon" />
							<span>{$t("hub.order.order_create")}</span>
						</div>
						{#if orderData.orderStatus !== "OPEN"}
							<div class="condition-widget">
								<div class="widget-bar" />
								<div class="widget payment-completed">
									<div class="check-icon" />
									<span>{$t("hub.order.order_completed")}</span>
								</div>
							</div>
						{/if}
						{#if orderData.orderStatus === "CANCELLED"}
							<div class="condition-widget">
								<div class="widget-bar" />
								<div class="widget payment-cancelled">
									<div class="x-icon">
										<XIcon fill={"#ffffff"} />
									</div>
									<span>{$t("hub.order.order_cancelled")}</span>
								</div>
							</div>
						{/if}
					</div>
					{#if orderStatus === "CLOSED" || (orderData.orderStatus === "CLOSED" && orderCancelBtnStatus)}
						<div class="order-cancel-widget change" on:click={orderCancelBtn}>
							<div class="x-btn" />
							<span>{$t("hub.order.change_order_cancel")}</span>
						</div>
					{/if}
					{#if orderData.orderStatus === "CANCELLED"}
						<!-- <div class="order-close-widget change" on:click={orderRevertBtn}>
							<span>{$t("hub.order.revert_order_to_complete")}</span>
						</div> -->
					{/if}
				</div>
				<div class="sub-box">
					<span class="title">{$t("hub.order.order_number")}</span>
					<div>
						<span class="content"
							>{`${orderData.id} (${orderData.shortid})`}</span
						>
						<img
							class="copy-img"
							src={copy}
							on:click={() =>
								clipboardCopy(`${orderData.id} (${orderData.shortid})`)}
						/>
					</div>
				</div>
				<div class="sub-box">
					<span class="title">{$t("hub.order.order_time")}</span>
					<span class="content">{processingDate(orderData.createdDate)}</span>
				</div>
				<div class="sub-box">
					<span class="title">{$t("hub.order.order_type")}</span>
					<span class="content"
						>{$t(`hub.order.orderType.${orderData.orderType}`)}</span
					>
				</div>
				<div class="sub-box">
					<span class="title">{$t("hub.order.payment_method")}</span>
					<div class="pay-method-box">
						<img
							class="pay-method-img"
							src={getPaymentImage(orderData.orderPaymentMethod || "")}
						/>
						<span class="content"
							>{$t(
								`hub.order.payment_type.${orderData.orderPaymentMethod}`
							)}</span
						>
					</div>
				</div>
			</div>
		</div>
	{:else}
		<div class="loading">
			<DefaultLoading />
		</div>
	{/if}

	<div class="total-receipt card">
		{#if orderData}
			<div class="detail-price">
				<div class="row">
					<span class="title">{$t("global.Individual_Discount")}</span>
					<span class="content">{orderData.itemDiscount}{$t("global.KRW")}</span
					>
				</div>
				<div class="row">
					<span class="title">{$t("global.Alpha_Discount")}</span>
					<span class="content">{orderData.discount}{$t("global.KRW")}</span>
				</div>
				<div class="row">
					<span class="title">{$t("hub.order.redeemed")}</span>
					<span class="content"
						>{formatNumber(computeRedeemdPoint(orderData))}{$t(
							"global.KRW"
						)}</span
					>
				</div>
				<div class="row">
					<span class="title">{$t("hub.order.total_before_tax")}</span>
					<span class="content"
						>{formatNumber(orderData.totalPriceBeforeTax)}{$t(
							"global.KRW"
						)}</span
					>
				</div>
				<div class="row">
					<span class="title">{$t("hub.order.tax")}</span>
					<span class="content"
						>{formatNumber(orderData.totalTax)}{$t("global.KRW")}</span
					>
				</div>
			</div>
			<div class="seperate-bar bottom" />
			<div class="row grand-total">
				<span>{$t("hub.order.total")}</span>
				<span>{formatNumber(orderData.grandTotalPrice)}{$t("global.KRW")}</span>
			</div>
		{:else}
			<div class="loading">
				<DefaultLoading />
			</div>
		{/if}
	</div>
</div>
<div class="link-copy">
	<img src={linkCopy} />
	<span on:click={() => clipboardCopy(orderDetailPath)}
		>{$t("hub.order.link_copy")}</span
	>
</div>

<style lang="scss">
	@import "../../../variables.scss";
	div {
		box-sizing: border-box;
	}

	.card {
		border-radius: 5px;
	}
	.card {
		width: 100%;
		padding: 10px;
		background-color: white;
		.row {
			display: flex;
		}
	}
	.loading {
		width: 30px;
		height: 30px;
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 0 auto;
	}

	.item-list {
		position: relative;
		display: flex;
		flex-direction: column;
		gap: 10px;
		padding-top: 45px;
		@include appleAdjustTextForSize(16);

		.header {
			color: #6d6f76;
		}

		.body {
			display: flex;
			flex-direction: column;
			gap: 10px;
			color: #46474b;

			.row {
				p {
					word-break: break-all;
				}
				.col {
					word-wrap: break-word;
					text-align: center;

					&.product {
						text-align: start;
					}
					&.total {
						text-align: end;
					}
				}
			}
		}

		.row {
			gap: 10px;
			&.option {
				font-size: 0.875rem;
				color: #6d6f76;
			}

			.col {
				display: flex;
				justify-content: center;
			}

			.product {
				justify-content: flex-start;
				flex-grow: 276;
				max-width: calc((100% - 5px) * (276 / 619));
			}
			.price {
				flex-grow: 144;
				max-width: calc((100% - 50px) * (144 / 619));
			}
			.count {
				flex-grow: 55;
				max-width: calc((100% - 55px) * (55 / 619));
			}
			.total {
				justify-content: flex-end;
				flex-grow: 144;
				max-width: calc((100% - 50px) * (144 / 619));
			}
		}
	}

	.seperate-bar {
		width: 100%;
		height: 1px;
		background-color: #e6e7ec;
		margin: 5.5px 0px;
	}
	.payment-wrapper {
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: 10px;
		@include appleAdjustTextForSize(14);
	}

	.payment-card {
		display: flex;
		gap: 10px;
		color: #46474b;
		.type,
		.total {
			font-weight: 500;
		}

		.total {
			font-size: 1.25rem;
		}
		img {
			width: 30px;
			height: 22.2px;
			object-fit: contain;
		}

		.payment-info-wrapper {
			display: flex;
			flex-direction: column;
			flex-grow: 1;
			flex-wrap: wrap;
			gap: 10px;

			.payment-title {
				font-weight: 600;
				@include appleAdjustTextForSize(20);
			}

			.payment-widget {
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				flex-wrap: wrap;
				gap: 10px;
				width: 100%;
				margin-bottom: 8px;

				.widget-box {
					display: flex;
					align-items: center;
					flex-wrap: wrap;
					row-gap: 10px;

					.condition-widget {
						display: flex;
						align-items: center;
					}

					.payment-cancelled {
						background-color: #f66d6c;

						span {
							color: white;
						}
					}
				}
				.check-icon {
					width: 13px;
					height: 10px;
					border-left: 1px solid #6d6f76;
					border-bottom: 1px solid #6d6f76;
					transform: rotate(-45deg);
					transform-origin: 25% 25%;
				}
				.x-icon {
					display: flex;
					width: 12px;
					height: 12px;
				}
				.widget {
					display: flex;
					justify-content: center;
					align-items: center;
					gap: 10px;
					width: 105px;
					height: 31px;
					background-color: #f0f0f4;
					border-radius: 15px;

					span {
						@include appleAdjustTextForSize(16);
						@include heightRelativeToFontSize(16);
						font-weight: 500;
						margin-right: 8px;
					}
				}
				.widget-bar {
					width: 20px;
					height: 1px;
					background-color: #d8d9df;
				}
				.payment-completed {
					display: flex;
				}

				.change {
					position: relative;
					display: flex;
					justify-content: center;
					align-items: center;
					width: 280px;
					height: 31px;
					border-radius: 22px;

					&::before {
						content: "";
						background-size: cover;
						position: absolute;
						top: 0px;
						right: 0px;
						bottom: 0px;
						left: 0px;
						opacity: 0.8;
						border-radius: 22px;
					}

					span {
						@include appleAdjustTextForSize(16);
						font-weight: 400;
						position: relative;
						color: white;
					}
				}
				.order-cancel-widget {
					background: radial-gradient(
						circle at 50% 50%,
						var(--red),
						#bc5352 65%,
						#000 108%
					);

					&::before {
						background-image: url("/img/icons/orderCancel.png");
					}

					.x-btn {
						width: 14px;
						height: 14px;
						margin-right: 2px;

						&::before,
						&::after {
							position: absolute;
							top: 8px;
							content: "";
							height: 16px;
							width: 1px;
							background-color: #fff;
						}
						&::before {
							transform: rotate(45deg);
						}
						&::after {
							transform: rotate(-45deg);
						}
					}
				}

				.order-close-widget {
					background: radial-gradient(
						circle at 50% 50%,
						#6591fa,
						#3357ad 65%,
						#000 108%
					);
					&::before {
						background-image: url("/img/icons/orderRevert.png");
					}
				}
			}
			.sub-box {
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				gap: 10px;

				.title {
					color: #6d6f76;
					@include appleAdjustTextForSize(14);
				}
				.content {
					color: #46474b;
					@include appleAdjustTextForSize(16);
				}
				div {
					display: flex;
					align-items: center;
					gap: 10px;
				}
				.copy-img {
					width: 20px;
					height: 20px;
					cursor: pointer;
				}

				.pay-method-box {
					display: flex;
					align-items: center;
					gap: 4px;
					span {
						margin-bottom: 3px;
					}
				}

				.pay-method-img {
					width: 30px;
					height: 22px;
				}
			}
		}
	}

	.total-receipt {
		.detail-price {
			display: flex;
			flex-direction: column;
			gap: 10px;
			color: #6d6f76;
		}
		.row {
			justify-content: space-between;

			.title {
				@include appleAdjustTextForSize(14);
			}
			.content {
				color: #46474b;
				@include appleAdjustTextForSize(16);
			}
		}

		.grand-total {
			font-weight: 500;
			color: #46474b;
			@include appleAdjustTextForSize(16);
		}
	}

	.link-copy {
		display: flex;
		align-items: center;
		width: fit-content;
		gap: 10px;
		border-bottom: 1px solid #416bcf;
		padding-bottom: 4px;
		img {
			width: 20px;
			height: 20px;
		}
		span {
			font-weight: 400;
			color: #3c68d6;
			@include appleAdjustTextForSize(16);
		}
	}

	@include DesktopSize {
		.card {
			width: auto;
			padding: 20px;
		}

		.item-list {
			width: 100%;
			min-width: 365px;
			padding-top: 70px;
			@include appleAdjustTextForSize(16, false);

			.body {
				.row {
					&.option {
						font-size: 1rem;
					}

					p {
						width: 100%;
					}
				}
			}

			.row {
				.product {
					justify-content: flex-start;
					flex-grow: 211;
					max-width: calc((100% - 30px) * (211 / 619));
				}
				.price {
					flex-grow: 164;
					max-width: calc((100% - 30px) * (164 / 619));
				}
				.count {
					flex-grow: 80;
					max-width: calc((100% - 30px) * (80 / 619));
				}
				.total {
					justify-content: flex-end;
					flex-grow: 164;
					max-width: calc((100% - 30px) * (164 / 619));
				}
			}
		}

		.seperate-bar {
			margin: 0px;
			&.bottom {
				margin: 10px 0px;
			}
		}

		.payment-wrapper {
			flex-direction: row;
			min-width: 387px;
			gap: 15px;
			@include appleAdjustTextForSize(16, false);
		}

		.payment-card {
			width: 100%;
			min-width: 350px;

			.payment-info-wrapper {
				justify-content: space-between;
				padding-top: 3px;
				gap: 13px;

				.payment-title {
					font-weight: 500;
					@include appleAdjustTextForSize(20, false);
				}

				.payment-widget {
					flex-direction: row;
					align-items: center;
					margin-bottom: 10px;

					.widget-box {
						row-gap: 10px;
					}

					.widget {
						width: 136px;
						height: 44px;
						border-radius: 22px;

						span {
							@include appleAdjustTextForSize(16, false);
							@include heightRelativeToFontSize(20);
						}
					}

					.change {
						width: 190px;
						height: 44px;
						cursor: pointer;
						span {
							@include appleAdjustTextForSize(16, false);
							font-weight: 400;
							position: relative;
							color: white;
						}
					}

					.order-cancel-widget {
						.x-btn {
							margin-right: unset;

							&::before,
							&::after {
								top: 12px;
								left: 23px;
								height: 20px;
							}
						}
					}
				}

				.sub-box {
					display: flex;
					flex-direction: row;
					align-items: center;
					gap: unset;

					.title {
						color: #46474b;
						@include appleAdjustTextForSize(14, false);
					}
					.content {
						@include appleAdjustTextForSize(16, false);
					}

					.pay-method-box {
						gap: 5px;
					}
				}

				.type,
				.total {
					@include appleAdjustTextForSize(20, false);
					@include heightRelativeToFontSize(24);
				}

				.type {
					min-width: 100px;
					flex-basis: auto;
				}

				.total {
					flex-basis: auto;
					order: 2;
				}
				.card-no {
					order: 3;
				}
			}
		}

		.total-receipt {
			width: 100%;

			.detail-price {
				gap: 10px;
				color: #46474b;
			}
			.row {
				.title {
					@include appleAdjustTextForSize(14, false);
				}
				.content {
					@include appleAdjustTextForSize(16, false);
				}
			}
			.grand-total {
				@include appleAdjustTextForSize(16, false);
			}
		}
		.link-copy {
			cursor: pointer;

			span {
				@include appleAdjustTextForSize(16, false);
			}
		}
	}

	.container {
		position: relative;
		display: flex;
		width: 273px;
		height: 30px;
		&.editmode {
			height: 40px;
		}

		button {
			all: unset;
			display: flex;
			background-color: #f0f0f4;
			border-radius: 5px;
			padding: 0px 10px;
			cursor: pointer;
		}

		.outer-button {
			justify-content: space-between;
			align-items: center;
			width: 100%;
		}

		.inner-container-button {
			width: 253px;
			max-height: 518px;
			overflow: hidden;
			position: absolute;
			display: flex;
			flex-direction: column;
			left: 0px;
			top: 50px;
			z-index: 1;
		}

		.category-box {
			display: flex;
			justify-content: space-between;
			align-items: center;
		}

		img {
			width: 20px;
			height: 10px;
		}
	}
</style>
